export function updateChats(state, value) {
  state.chats = value;
}

export function updateComments(state, value) {
  state.comments = value.sort((a, b) => {
    console.log(a.createdAt);
    return a.createdAt._seconds > b.createdAt._seconds;
  });
}
